import axios from "axios";
import { proxyServer } from "../assets/constantes";


export const createUserAdmin = async (data)=>{
  
  try {
    const response = await axios.post(`${proxyServer}api/createUserAdmin`,data);
    const objRes={
      msg: 'Response createUserAdmin:..',
      response
    }
    console.log(objRes);
    return objRes
  } catch (error) {
    console.log(error);
    return error
  }
}

export const getAllAdminUsers = async ()=>{
  
  try {
    const response = await axios.get(`${proxyServer}api/getAllAdminUsers`);
    const objRes= {
      msg: 'Response getAllAdminUsers:..',
      response
    }
    console.log(objRes);
    return objRes
  } catch (error) {
    console.log(error);
    return error
  }
}

export const deleteUserAdminById = async (id)=>{
  try {
    const response = await axios.delete(`${proxyServer}api/deleteUserAdminById/${id}`);
    const objRes ={
      msg: 'Borrando userAdmin...',
      response
    }
    console.log(objRes);
    return objRes
  } catch (error) {
    console.log(error);
    return error
  }
}

export const updateUserAdminById = async (id,data)=>{
  try {
    const response = await axios.put(`${proxyServer}api/updateUserAdminById/${id}`,data);
    const objRes ={
      msg: 'Editando userAdmin...',
      response
    }
    console.log(objRes);
    return objRes
  } catch (error) {
    console.log(error);
    return error
  }
}


export const findUserAdminInDB = async (dataLogin)=>{
  try {
    const response = await axios.post(`${proxyServer}api/findUserAdminInDB`,dataLogin);
    const objRes ={
      msg: 'Buscando userAdmin...',
      response
    }
    console.log(objRes);
    return objRes
  } catch (error) {
    console.log(error);
    return error
  }
}

export const getUsersByFilterDate = async (dateScope)=>{
  try {
    const response = await axios.post(`${proxyServer}api/getUsersByFilterDate`,dateScope);
    const objRes={
      msg: 'Response getUsersByFilterDate:..',
      response
    }
    console.log(objRes);
    return objRes
  } catch (error) {
    console.log(error);
    return error
  }
}

export const findUserByEmailInOldDB = async (emailUser)=>{
  const localProxyServer = 'http://localhost:8000/';
  try {
    const response = await axios.get(`${proxyServer}api/findUserByEmailInOldDB/${emailUser}`);
    const objRes ={
      msg: 'Busqueda user:...',
      response
    }
    console.log(objRes);
    return objRes
  } catch (error) {
    console.log(error);
    return error
  }
}

export const getUsersByFilterDateOldDB = async (dateScope)=>{
  const localProxyServer = 'http://localhost:8000/';
  try {
    const response = await axios.post(`${proxyServer}api/getUsersByFilterDateOldDB`,dateScope);
    const objRes={
      msg: 'Response getUsersByFilterDate:..',
      response
    }
    console.log(objRes);
    return objRes
  } catch (error) {
    console.log(error);
    return error
  }
}